import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "@src/utils/axios/AxiosProvider";
import useZustandStore from "@src/helpers/zustand";

interface DataType {
  apiKey?: string;
  expectedTurnoverCode?: string;
}

const apiCall = async ({ apiKey, expectedTurnoverCode }: DataType) => {
  const response = await axiosInstance.post<unknown>(
    "/api/customer/finish",
    { expectedTurnoverCode },
    {
      headers: {
        "x-api-key": apiKey,
      },
    }
  );
  return response.data;
};

export const useFinishCustomer = () => {
  const navigate = useNavigate();
  const { data: zData, setData } = useZustandStore((state) => state);

  const { i18n } = useTranslation();
  return useMutation(apiCall, {
    onSuccess() {
      navigate(
        `/${i18n.language}/almost-done?redirected_from=identify-with-payunicard`
      );
    },
    onError({ response }) {
      setData({
        ...zData,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- we trust the api
        errorMessage: response.data.displayText || response.data.DisplayText,
      });
      navigate(`/${i18n.language}/error`);
    },
  });
};
